import React from "react";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import img1 from '../Ecomphotos/jodhpur.jpg'
import img2 from '../Ecomphotos/rajasthani.jpg'
import img3 from '../Ecomphotos/jaisal.jpg'
import img4 from '../Ecomphotos/salji2.jpg'

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

export default function Slider() {
  return (
    <Container fluid className="p-0 ">
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        <SwiperSlide className="">
          <img
            src={img1}
            alt="slide1"
            className=" d-block w-100 expert"
          />
          <div className="slider-text-overlay">
        <h1>Welcome to Jawali Holidays</h1>
        <p>Experience the Royal Rajasthan with Jawali Holidays.</p>
        <button>Explore Rajasthan</button>
      </div>
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={img2}
            alt="slide2"
            className=" d-block w-100 expert"
          />
              <div className="slider-text-overlay">
        <h1>Padharo Mhare Desh</h1>
        <p>Best Rajasthan Tour Packages at Unbeatable Prices.</p>
        <button>Your Trip</button>
      </div>
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={img3}
            alt="slide3"
            className=" d-block w-100 expert"
          />
              <div className="slider-text-overlay">
        <h1>The Magic of Thar Desert</h1>
        <p>Camel Safari, Jeep Safari & Luxury Camping in Jaisalmer.</p>
        <button>Book Safari</button>
      </div>
        </SwiperSlide>
          <SwiperSlide>
          <img
            src={img4}
            alt="slide4"
            className=" d-block w-100 expert"
          />
              <div className="slider-text-overlay">
        <h1>Jodhpur's Trusted Travel Partner</h1>
        <p>Making your holidays memorable and hassle-free.</p>
        <button>Contact Us</button>
      </div>
        </SwiperSlide>
      </Swiper>
    </Container>
  );
}

